import { withCompInfo } from '../../core/withCompInfo'
import { SingleAudioPlayerDefinition, SingleAudioPlayerProps, SingleAudioPlayerCSSVars } from './types'
import { SKIN_HEIGHT_MAP } from './constants'

export const props = withCompInfo<SingleAudioPlayerProps, SingleAudioPlayerDefinition>(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const { volume, autoPlay, loop } = compProps
		const { uri, originalFileName, track, artist } = compData
		return { volume, autoPlay, loop, uri, originalFileName, track, artist }
	}
)

export const css = withCompInfo<SingleAudioPlayerCSSVars, SingleAudioPlayerDefinition>(
	['isMobileView', 'skin'],
	({ isMobileView, skin }) => {
		const view = isMobileView ? 'mobile' : 'desktop'
		return { height: SKIN_HEIGHT_MAP[skin][view] }
	}
)
